// import the library version of axios
import axios from "axios";
// create a version of axios with useful defaults
export default axios.create({
    baseURL: process.env.GATSBY_BASE_URL,
    headers: {
        "Content-type": "application/x-www-form-urlencoded",
    },
});